import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AppConfig } from '../../app.config';
import {LocalUtils} from '../../restricted/restricted.utils';

@Injectable()
export class HeaderService {

static connecting = new EventEmitter<any>(); 
static toaster = new EventEmitter<any>();
static sidebar = new EventEmitter<boolean>();
static minimized = new EventEmitter<boolean>();
static buttonColor = new EventEmitter<string>();
static navbarColor = new EventEmitter<string>();
static sidebarColor = new EventEmitter<string>();
static sidebarItemColor = new EventEmitter<string>();
static sidebarHoverColor = new EventEmitter<string>();
static minimized2 = new EventEmitter<boolean>();
static navbarImages = new EventEmitter<any>();
static breadcrumbsImages = new EventEmitter<any>();
static changeRoom = new EventEmitter<boolean>();
static changeSubroom = new EventEmitter<boolean>();
static changeLocale = new EventEmitter<string>();
static textSidebarColor = new EventEmitter<string>();
static meeting = new EventEmitter<any>(); 
static add = new EventEmitter<any>(); 
static setting = new EventEmitter<any>(); 
static speech = new EventEmitter<any>(); 
static feedback = new EventEmitter<any>(); 
static fullscreen = new EventEmitter<any>(); 
static dial = new EventEmitter<any>(); 
static ua = new EventEmitter<any>();
static chat = new EventEmitter<any>();
static dashboard = new EventEmitter<string>();
static scheduleOnWeb = new EventEmitter<string>();
static scheduleOnVideo = new EventEmitter<string>();
static scheduleOnRoom = new EventEmitter<string>();
static scheduleOnDesk = new EventEmitter<string>();
static modalScheduled = new EventEmitter<string>();
static addLocale = new EventEmitter<string>();
static localeAdded = new EventEmitter<string>();
static scheduleGeneral = new EventEmitter<string>();
static scheduledGeneral = new EventEmitter<string>();
static userUpdated = new EventEmitter<string>();

  constructor(private http: HttpClient,
    private appConfig: AppConfig) { }

  sidebarEmit(open) {
    HeaderService.sidebar.emit(open);
  }

  sidebarMinimized(isIt) {
    HeaderService.minimized.emit(isIt);
  }

  navColorEmit(color) {
    HeaderService.navbarColor.emit(color);
  }

  config(model) {
    return this.http.post(this.appConfig.apiUrl + '/config', model)
    //.catch(this.handleError);
  }

  getApiUrl() {
    return this.http.get('assets/app.config.json')
    //.catch(this.handleError);
  }

  setApiUrl(model) {
    return this.http.get('assets/server.php?keyServer=' + model.keyServer + '&domain=' + model.domain)
    //.catch(this.handleError);
  }

  socket() {
    let headers = this.createAuthorizationHeader();
    return this.http.get(this.appConfig.apiUrl + '/sockets', { headers: headers })
      .map(this.extractData)
    //.catch(this.handleError)
  }


  private extractData(res: Response) {
    let body = (<any>res).records;
    return body || { };
  }

  private handleError (error: Response | any) {
    //const expiredToken = LocalUtils.expiredToken(error);
    //return Observable.throw(expiredToken);
  } 

  createAuthHeader(login, password): HttpHeaders {
    return new HttpHeaders().set('Authorization', "Basic " + btoa(login + ":" + password));
  }

  createContentHeader():HttpHeaders {
    return new HttpHeaders().set('Accept', 'text/plain');
  }

  createAuthorizationHeader():HttpHeaders {
    return new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8')
    .set('Authorization', LocalUtils.decrypt(localStorage.getItem("token")));
  }

}


// WEBPACK FOOTER //
// ./src/app/components/app-header/app.header.service.ts